import {useEffect} from 'react'

import {useImpersonation} from '../hooks/useImpersonation'

/**
 * Barra fija que avisa que la sesión en curso es una suplantación, con el botón
 * para volver a la sesión propia. Se monta siempre; no renderiza nada cuando no
 * hay suplantación activa.
 */
const ImpersonationBanner = () => {
  const {isImpersonating, busy, targetLabel, adminLabel, stopImpersonation} = useImpersonation()

  // Empuja el layout hacia abajo para que la barra no tape el header.
  useEffect(() => {
    const className = 'tfi-impersonating'
    document.body.classList.toggle(className, isImpersonating)
    return () => document.body.classList.remove(className)
  }, [isImpersonating])

  if (!isImpersonating) return null

  return (
    <>
      <style>
        {`
          body.tfi-impersonating #kt_app_root { padding-top: 40px; }
          body.tfi-impersonating #kt_app_header { top: 40px; }
        `}
      </style>
      <div
        className='d-flex align-items-center justify-content-center gap-3 px-4 text-white'
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 40,
          zIndex: 1050,
          backgroundColor: '#d9214e',
          fontSize: '0.9rem',
        }}
      >
        <span>
          <i className='bi bi-incognito text-white me-2' />
          You are viewing the system as <strong>{targetLabel}</strong>
          {adminLabel ? ` — your session as ${adminLabel} is still saved` : ''}
        </span>
        <button
          type='button'
          className='btn btn-sm btn-light py-1 px-3'
          disabled={busy}
          onClick={stopImpersonation}
        >
          {busy ? 'Returning…' : 'Back to my session'}
        </button>
      </div>
    </>
  )
}

export {ImpersonationBanner}
